import * as React from 'react';
import { Row, Col, Button, Modal, Form, Table, FormControl, Card } from 'react-bootstrap';
import { RouteComponentProps, Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import {
    STORE_USERS, STORE_COMMON
} from '../../constants';
import { UsersStore, CommonStore } from '../../stores';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LinkContainer } from 'react-router-bootstrap';
import AddUserModal from './AddUserModal';

interface IProps {
    [STORE_USERS]: UsersStore,
    [STORE_COMMON]: CommonStore
}

interface IState {
    addUserModalIsOpened: boolean
}

type Props = IProps
    & RouteComponentProps<{}>



@inject(STORE_USERS, STORE_COMMON)
@observer
export default class UsersPage extends React.Component<Props, IState> {
    constructor(props: any) {
        super(props);

        this.state = {
            addUserModalIsOpened: false
        };
    }

    usersStore = this.props[STORE_USERS];
    commonStore = this.props[STORE_COMMON];

    

    componentDidMount() {
        document.title = `${this.commonStore.currentPageName} - ${this.commonStore.appName}`;
        this.commonStore.setPageName("Настройка прав доступа");
        this.loadData();
    }

    private loadData = () => {
        this.usersStore.loadUsers();
    }

    private createUser = (email: string, password: string, lastName: string, firstName: string, middleName: string) => {
        this.usersStore.createUser(email, password, lastName, firstName, middleName, () => {
            this.setState({
                addUserModalIsOpened: false
            })
        });
    }
    private removeUser = (userId: string, userFio: string) => {

        if (window.confirm(`Вы хотите удалить пользователя [${userFio}]. Продолжить?`)) {
            this.usersStore.removeUser(userId);
        }
    }

    render() {
        return <div>
            <Row>
                <Col sm={8}>
                    <h1>
                        {this.commonStore.currentPageName}
                    </h1>
                </Col>
                <Col sm={4} className="text-right">
                    <Button variant="primary" onClick={() => {
                        this.setState({
                            addUserModalIsOpened: true
                        })
                    }} size="sm">
                        <FontAwesomeIcon icon="plus" />
                        Добавить пользователя
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col sm={12}>

                    <br />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Table bordered striped className="table-xxs" >
                        <thead>
                            <tr>
                                <th className="text-center">#</th>
                                <th className="text-center">Фио</th>
                                <th className="text-center">Email</th>
                                <th className="text-center">Количество ролей</th>
                                <th className="text-center">Изменить</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.usersStore.users.map((item, index) => <tr key={index}>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-center">{item.userFio}</td>
                                <td className="text-center">{item.email}</td>
                                <td className="text-center">{item.rolesCount}</td>
                                <td className="text-center">
                                    <LinkContainer to={`/users/editroles/${encodeURIComponent(item.userId)}`}>
                                        <Link to={`/users/editroles/${encodeURIComponent(item.userId)}`}>
                                            <FontAwesomeIcon icon="pen" /> Ред.
                                        </Link>
                                    </LinkContainer>
                                    <span style={{ marginLeft: "20px", cursor: "pointer" }} title="Удалить пользователя" onClick={() => this.removeUser(item.userId, item.userFio)}>
                                        <FontAwesomeIcon icon="trash" />
                                    </span>
                                </td>
                            </tr>)}
                        </tbody>
                    </Table>
                </Col>
            </Row>
            <AddUserModal
                isOpened={this.state.addUserModalIsOpened}
                closeModal={() => { this.setState({ addUserModalIsOpened: false }) }}
                createUser={this.createUser} />
        </div>
    }

}